/* Marla · Ficha de producto (rediseño Buen Fin 2026) · parte 1 de 2.
   Variante, cantidad, precio con "Compra más, ahorra más" y datos del carrito.
   La parte 2 (marla-pdp-ui.js) agrega galería, ayudas, barra fija y arranque.
   El carrito lo maneja product-form.js + cart-drawer.js. */
(function () {
  'use strict';

  var PREVIEW_KEY = 'mjBfPreview';

  function readPreviewFlag() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('mj_bf') === '1') sessionStorage.setItem(PREVIEW_KEY, '1');
      if (params.get('mj_bf') === '0') sessionStorage.removeItem(PREVIEW_KEY);
      return sessionStorage.getItem(PREVIEW_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function money(cents) {
    var value = Math.round(cents) / 100;
    var whole = Math.abs(value - Math.round(value)) < 0.001;
    return (
      '$' +
      value.toLocaleString('es-MX', {
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2,
      })
    );
  }

  function readJSON(root, selector) {
    var el = root.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /* Datos del carrito que pinta el carrito lateral (snippets/cart-drawer.liquid). */
  function readCartData() {
    var el = document.querySelector('[data-mj-cart]');
    if (!el) return null;
    return {
      eligible: parseInt(el.getAttribute('data-eligible'), 10) || 0,
      count: parseInt(el.getAttribute('data-count'), 10) || 0,
    };
  }

  function MarlaPDP(root) {
    this.root = root;
    this.product = readJSON(root, '[data-mj-product-json]');
    this.config = readJSON(root, '[data-mj-config]') || {};
    if (!this.product) return;

    this.preview = readPreviewFlag();
    this.offerLive = !!this.config.on && (this.config.live || this.preview);

    this.form = root.querySelector('[data-mj-product-form] form');
    this.productForm = root.querySelector('[data-mj-product-form]');
    this.idInput = root.querySelector('[data-mj-variant-id]');
    this.qtyInput = root.querySelector('[data-mj-qty-input]');
    this.atc = root.querySelector('[data-mj-atc]');
    this.atcLabel = root.querySelector('[data-mj-atc-label]');
    this.fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-mj-option]'));
    this.variant = this.findVariant(this.getSelectedValues());
    if (!this.variant && this.product.variants.length === 1 && this.fieldsets.length === 0) {
      this.variant = this.product.variants[0];
    }

    this.cart = readCartData() || { eligible: 0, count: 0 };
    this.pickup = readJSON(root, '[data-mj-pickup-json]') || {};

    this.initOffer();
    this.initOptions();
    this.initQuantity();
    this.initSubmitGuard();
    this.initGallery();
    this.initPopovers();
    this.initSticky();
    this.initWelcome();
    this.watchCart();
    this.updateAvailability();
    this.render(false);
  }

  MarlaPDP.prototype.getSelectedValues = function () {
    return this.fieldsets.map(function (fs) {
      var checked = fs.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });
  };

  MarlaPDP.prototype.findVariant = function (values) {
    if (values.some(function (v) { return v === null; })) return null;
    for (var i = 0; i < this.product.variants.length; i++) {
      var v = this.product.variants[i];
      var match = values.every(function (value, idx) {
        return v.options[idx] === value;
      });
      if (match) return v;
    }
    return null;
  };

  /* Qué cuenta para la promo (snippets/marla-offer-config.liquid):
     all = todas las piezas menos tarjetas de regalo; coll = solo la colección del descuento;
     sale = las que no tienen precio de rebaja. */
  MarlaPDP.prototype.isEligible = function (variant) {
    if (!variant) return false;
    if (this.config.mode === 'all') return !this.config.giftCard;
    if (this.config.mode === 'coll') return !!this.config.inColl;
    return !(variant.compare_at_price && variant.compare_at_price > variant.price);
  };

  MarlaPDP.prototype.tierFor = function (cents) {
    if (!this.offerLive) return 0;
    if (cents >= this.config.t2) return this.config.p2;
    if (cents >= this.config.t1) return this.config.p1;
    return 0;
  };

  /* ---------- Opciones ---------- */
  MarlaPDP.prototype.initOptions = function () {
    var self = this;
    this.fieldsets.forEach(function (fs) {
      fs.addEventListener('change', function () {
        self.variant = self.findVariant(self.getSelectedValues());
        self.clearNudge();
        self.clearFormError();
        self.updateAvailability();
        self.render(true);
      });
    });
  };

  /* Marca valores agotados según lo que ya está elegido en las otras opciones. */
  MarlaPDP.prototype.updateAvailability = function () {
    var self = this;
    var selected = this.getSelectedValues();
    this.fieldsets.forEach(function (fs, idx) {
      fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var available = self.product.variants.some(function (v) {
          if (!v.available || v.options[idx] !== input.value) return false;
          return selected.every(function (val, j) {
            return j === idx || val === null || v.options[j] === val;
          });
        });
        var label = fs.querySelector('label[for="' + input.id + '"]');
        var out = label && label.querySelector('[data-mj-out]');
        input.disabled = !available && !input.checked;
        if (label) label.classList.toggle('is-out', !available);
        if (out) out.hidden = available;
      });
    });
  };

  MarlaPDP.prototype.showNudge = function () {
    var missing = this.fieldsets.filter(function (fs) {
      return !fs.querySelector('input[type="radio"]:checked');
    });
    if (!missing.length) return;
    missing.forEach(function (fs) {
      fs.classList.add('is-missing');
      var alert = fs.querySelector('[data-mj-nudge]');
      var value = fs.querySelector('[data-mj-opt-value]');
      if (alert) alert.hidden = false;
      if (value) value.textContent = value.getAttribute('data-missing');
    });
    var first = missing[0];
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    first.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    var firstInput = first.querySelector('input[type="radio"]:not(:disabled)');
    if (firstInput) firstInput.focus({ preventScroll: true });
  };

  MarlaPDP.prototype.clearNudge = function () {
    this.fieldsets.forEach(function (fs) {
      if (!fs.querySelector('input[type="radio"]:checked')) return;
      fs.classList.remove('is-missing');
      var alert = fs.querySelector('[data-mj-nudge]');
      if (alert) alert.hidden = true;
    });
  };

  /* ---------- Cantidad ---------- */
  MarlaPDP.prototype.initQuantity = function () {
    var self = this;
    this.root.querySelectorAll('[data-mj-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-mj-qty'), 10);
        var current = parseInt(self.qtyInput.value, 10) || 1;
        self.qtyInput.value = Math.max(1, current + step);
        self.clearFormError();
        self.render(false);
      });
    });
    this.qtyInput.addEventListener('change', function () {
      var value = parseInt(self.qtyInput.value, 10);
      if (!value || value < 1) self.qtyInput.value = 1;
      self.clearFormError();
      self.render(false);
    });
  };

  /* Borra el aviso de error del carrito (product-form.js) al cambiar color o cantidad. */
  MarlaPDP.prototype.clearFormError = function () {
    var pf = this.productForm;
    if (pf && typeof pf.handleErrorMessage === 'function') pf.handleErrorMessage();
  };

  /* Sin variante elegida no se envía nada: se marca la opción que falta. */
  MarlaPDP.prototype.initSubmitGuard = function () {
    var self = this;
    if (!this.productForm || !this.form) return;
    this.productForm.addEventListener(
      'submit',
      function (event) {
        if (!self.variant) {
          event.preventDefault();
          event.stopPropagation();
          self.showNudge();
        } else if (!self.variant.available) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );
  };

  /* ---------- Render ---------- */
  MarlaPDP.prototype.render = function (fromUser) {
    var v = this.variant;
    var root = this.root;

    if (this.idInput) this.idInput.value = v ? v.id : '';

    var multi = this.fieldsets.length > 0;
    var titleColor = root.querySelector('[data-mj-title-color]');
    var titleName = root.querySelector('[data-mj-title-color-name]');
    if (titleColor && multi) {
      titleColor.hidden = !v;
      if (v && titleName) titleName.textContent = v.title;
    }

    var self = this;
    this.fieldsets.forEach(function (fs) {
      var checked = fs.querySelector('input[type="radio"]:checked');
      var value = fs.querySelector('[data-mj-opt-value]');
      if (!value) return;
      if (checked) value.textContent = checked.value;
      else if (!fs.classList.contains('is-missing')) value.textContent = value.getAttribute('data-empty');
    });

    // Botón
    var available = v ? v.available : this.product.available;
    if (this.atc) {
      this.atc.disabled = !available;
      if (this.atcLabel) this.atcLabel.textContent = available ? this.config.atc || 'Agregar al carrito' : 'Agotado';
    }

    // URL
    if (fromUser && v && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    // Galería
    if (fromUser && v) this.showVariantMedia(v);

    this.renderPickup();
    this.renderPrice();
    this.renderTiers();
    this.renderSticky();
  };

  /* Tarjeta "Recogida disponible en …" según el color elegido (datos de Shopify). */
  MarlaPDP.prototype.renderPickup = function () {
    var card = this.root.querySelector('[data-mj-pickup]');
    if (!card || !this.variant) return;
    var info = this.pickup[String(this.variant.id)];
    card.hidden = !info;
    if (!info) return;
    var set = function (sel, text) {
      var el = card.querySelector(sel);
      if (el) el.textContent = text || '';
    };
    set('[data-mj-pickup-name]', info.name);
    set('[data-mj-pickup-city]', info.city);
    set('[data-mj-pickup-time]', info.time);
  };

  MarlaPDP.prototype.renderPrice = function () {
    var v = this.variant;
    var root = this.root;
    var now = root.querySelector('[data-mj-now]');
    var was = root.querySelector('[data-mj-was]');
    var note = root.querySelector('[data-mj-cartline]');
    var base = v || this.product.variants.find(function (x) { return x.available; }) || this.product.variants[0];
    if (!base || !now) return;

    var qty = parseInt(this.qtyInput.value, 10) || 1;
    var eligible = this.isEligible(base);
    var projected = this.cart.eligible + (eligible ? base.price * qty : 0);
    var pct = eligible ? this.tierFor(projected) : 0;

    if (pct > 0) {
      var unitOff = Math.round(base.price * pct) / 100;
      was.textContent = money(base.price);
      was.hidden = false;
      now.textContent = money(base.price - unitOff);
      if (note) {
        var pieces = this.cart.count + qty;
        note.textContent = 'Al agregar: ' + pieces + (pieces === 1 ? ' pieza' : ' piezas') + ' en tu carrito · ' + pct + '% off';
        note.hidden = false;
      }
    } else {
      var compare = base.compare_at_price && base.compare_at_price > base.price ? base.compare_at_price : 0;
      was.textContent = compare ? money(compare) : '';
      was.hidden = !compare;
      var varies = !v && this.product.price_varies;
      now.textContent = (varies ? 'Desde ' : '') + money(v ? v.price : this.product.price_min);
      if (note) note.hidden = true;
    }
  };

  MarlaPDP.prototype.renderTiers = function () {
    var tierCards = this.root.querySelectorAll('[data-mj-tier]');
    if (!tierCards.length) return;
    var pct = this.tierFor(this.cart.eligible);
    var activeLevel = pct === this.config.p2 && pct > 0 ? 2 : pct === this.config.p1 && pct > 0 ? 1 : 0;
    tierCards.forEach(function (card) {
      var level = parseInt(card.getAttribute('data-mj-tier'), 10);
      var on = level === activeLevel;
      card.classList.toggle('is-active', on);
      var tag = card.querySelector('[data-mj-tier-on]');
      if (tag) tag.hidden = !on;
    });
  };

  /* ---------- Oferta ---------- */
  MarlaPDP.prototype.initOffer = function () {
    var offer = this.root.querySelector('[data-mj-offer]');
    var reg = this.root.querySelector('[data-mj-offer-reg]');
    if (offer) offer.hidden = !this.offerLive;
    if (reg) reg.hidden = this.offerLive || !reg.querySelector('.mj-offer__title, .mj-offer__link');
  };

  MarlaPDP.prototype.watchCart = function () {
    var self = this;
    var drawer = document.querySelector('cart-drawer');
    var refresh = function () {
      var data = readCartData();
      if (!data) return;
      self.cart = data;
      self.renderPrice();
      self.renderTiers();
      self.renderSticky();
      applyDrawerPreview();
    };
    if (drawer && window.MutationObserver) {
      var timer;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(refresh, 60);
      }).observe(drawer, { childList: true, subtree: true });
    }
  };

  /* ---------- Vista previa de la oferta en el carrito ---------- */
  function applyDrawerPreview() {
    if (!readPreviewFlag()) return;
    document.querySelectorAll('[data-mj-bf]').forEach(function (el) { el.hidden = false; });
    document.querySelectorAll('[data-mj-reg]').forEach(function (el) { el.hidden = true; });
  }

  MarlaPDP.utils = {
    readPreviewFlag: readPreviewFlag,
    money: money,
    readCartData: readCartData,
    applyDrawerPreview: applyDrawerPreview,
  };
  window.MarlaPDP = MarlaPDP;
})();